<div class="input-checkbox" lines="none">
  <div class="input-checkbox__row input-checkbox__row--nocenter">
    <label>
      <input type="checkbox" [(ngModel)]="value" (ngModelChange)="onChange()" />
      <span class="checkmark"></span>
    </label>
    <div>
      <ng-content></ng-content>
    </div>
  </div>
</div>
